import api from './api';

export const createDailyReport = (data) => api.post('/daily-reports/', data);

export const getDailyReports = (reportDate, params = {}) =>
  api.get(`/daily-reports/${reportDate}`, { params });

export const previewCost = (employeeIds = [], hours, absentIds = []) =>
  api.get('/daily-reports/calculate-cost/preview', {
    params: { employee_ids: employeeIds.join(','), hours, absent_ids: absentIds.join(',') },
  });
